import { colorTokens } from '../tokens/colorTokens'

export const alertTheme = {
    MuiAlert: {
        styleOverrides: {
            root: {
                '&.MuiAlert-colorInfo': {
                    backgroundColor: colorTokens.status.infoSurface,
                    color: colorTokens.status.infoText,
                    '& .MuiAlert-icon': {
                        color: colorTokens.status.infoIcon,
                    },
                },
            },
        },
    },
}